module.exports = __webpack_public_path__ + "static/img/Jobe-Shanahan.2a9b360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jobe-Shanahan.jpg
// module id = 61Ow
// module chunks = 0